import { render, staticRenderFns } from "./InternationalPhone.vue?vue&type=template&id=070dbc3d"
import script from "./InternationalPhone.vue?vue&type=script&lang=js"
export * from "./InternationalPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports